export default __webpack_public_path__ + "static/media/wb-logo.06ab1b95.svg";